import {createSlice, isAnyOf} from '@reduxjs/toolkit';
import {getInitialState} from './initialState';
import {
  cancelParkingReservation,
  changeParkingSpot,
  loadParkingCount,
  loadParkingCountByDateRange,
  removeParkingSpot,
  reserveParkingSpot,
  reserveParkingSpotWithPreferredLocation,
} from './actions';
import {loadMyParkingReservations} from './actions';
import {parkingReservationsAdapter} from './adapters';

const initialState = getInitialState();
const slice = createSlice({
  name: 'parkingReservation',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadMyParkingReservations.pending, (state) => {
        state.isLoadingParkingReservations = true;
      })
      .addCase(loadMyParkingReservations.fulfilled, (state, action) => {
        parkingReservationsAdapter.setAll(state.parkingReservations, action.payload ?? []);
      })
      .addCase(loadParkingCount.pending, (state) => {
        state.isLoadingParkingCount = true;
      })
      .addCase(loadParkingCount.fulfilled, (state, action) => {
        state.parkingCountPerNodeOnDate = {...state.parkingCountPerNodeOnDate, ...action.payload};
      })
      .addCase(loadParkingCountByDateRange.pending, (state) => {
        state.isLoadingParkingCount = true;
      })
      .addCase(loadParkingCountByDateRange.fulfilled, (state, action) => {
        state.parkingCountPerNodeOnDate = action.payload;
      })
      .addCase(reserveParkingSpot.pending, (state) => {
        state.isReservingParkingSpot = true;
      })
      .addCase(reserveParkingSpot.fulfilled, (state, action) => {
        parkingReservationsAdapter.addOne(state.parkingReservations, action.payload);
      })
      .addCase(reserveParkingSpotWithPreferredLocation.pending, (state) => {
        state.isReservingParkingSpot = true;
      })
      .addCase(reserveParkingSpotWithPreferredLocation.fulfilled, (state, action) => {
        parkingReservationsAdapter.addOne(state.parkingReservations, action.payload);
      })
      .addCase(changeParkingSpot.fulfilled, (state, action) => {
        const updatedParkingSpot = action.payload;
        parkingReservationsAdapter.updateOne(state.parkingReservations, {
          id: updatedParkingSpot.id,
          changes: updatedParkingSpot,
        });
      })
      .addCase(removeParkingSpot.pending, (state) => {
        state.isRemovingParkingSpot = true;
      })
      .addCase(removeParkingSpot.fulfilled, (state, action) => {
        if (!action.payload) return;
        parkingReservationsAdapter.removeOne(state.parkingReservations, action.payload);
      })
      .addCase(cancelParkingReservation, (state, action) => {
        parkingReservationsAdapter.removeOne(state.parkingReservations, action.payload);
      })
      .addMatcher(
        isAnyOf(
          reserveParkingSpot.fulfilled,
          reserveParkingSpot.rejected,
          reserveParkingSpotWithPreferredLocation.fulfilled,
          reserveParkingSpotWithPreferredLocation.rejected,
          changeParkingSpot.fulfilled,
          changeParkingSpot.rejected,
        ),
        (state) => {
          state.isReservingParkingSpot = false;
        },
      )
      .addMatcher(isAnyOf(loadMyParkingReservations.rejected, loadMyParkingReservations.fulfilled), (state) => {
        state.isLoadingParkingReservations = false;
      })
      .addMatcher(isAnyOf(reserveParkingSpot.fulfilled, reserveParkingSpot.rejected), (state) => {
        state.isReservingParkingSpot = false;
      })
      .addMatcher(
        isAnyOf(
          loadParkingCount.rejected,
          loadParkingCount.fulfilled,
          loadParkingCountByDateRange.rejected,
          loadParkingCountByDateRange.fulfilled,
        ),
        (state) => {
          state.isLoadingParkingCount = false;
        },
      )
      .addMatcher(isAnyOf(reserveParkingSpot.pending, changeParkingSpot.pending), (state) => {
        state.isReservingParkingSpot = true;
      })
      .addMatcher(isAnyOf(removeParkingSpot.rejected, removeParkingSpot.fulfilled), (state) => {
        state.isRemovingParkingSpot = false;
      });
  },
});

export const parkingReservationReducer = slice.reducer;
